import Page from "components/Page";
import { Props } from "./PaymentOptionTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const PaymentOptionTypes = lazyWithRetry(() => import("./PaymentOptionTypes"));

export default (props: Props) => (
  <Page>
    <PaymentOptionTypes {...props} />
  </Page>
);
